// Hook custom per recuperare la lista dei contratti tramite API.
// Nota: uso axios e TypeScript per tipizzare la risposta e gestire errori e loading.

import { useState, useEffect } from "react";
import axios from "axios";

// Prendo la base URL dell'API dalle variabili d'ambiente
const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Tipo per rappresentare un contratto
interface Contratto {
  id: number;
  contratto: string;
}

/**
 * useGetContratti
 * @returns { contratti, loading, error }
 *
 * Nota per il prossimo dev:
 * - `contratti` contiene un array di Contratto[]
 * - `loading` è true mentre la chiamata è in corso
 * - `error` contiene un messaggio di errore in caso di fallimento
 */
export const useGetContratti = () => {
  const [contratti, setContratti] = useState<Contratto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Funzione async per recuperare i contratti
    const fetchContratti = async () => {
      try {
        // Chiamata GET all'endpoint /contratti
        const response = await axios.get(`${API_BASE_URL}/contratti`);
        setContratti(response.data);
      } catch (err: unknown) {
        if (err instanceof Error) {
          console.error("Errore fetch contratti:", err.message);
        }
        setError("Impossibile recuperare i contratti");
      } finally {
        setLoading(false);
      }
    };

    // Invoco la funzione al mount del componente
    fetchContratti();
  }, []); // dipendenze vuote: chiamata solo al primo render

  return { contratti, loading, error };
};

export default useGetContratti;